var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorShevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45194 0.747429L8.00746 6.24724L13.563 0.747429C13.6956 0.616196 13.8529 0.512097 14.0261 0.441075C14.1993 0.370052 14.385 0.333496 14.5724 0.333496C14.7599 0.333496 14.9455 0.370052 15.1187 0.441075C15.2919 0.512097 15.4493 0.616196 15.5819 0.747429C15.7144 0.878662 15.8196 1.03446 15.8913 1.20592C15.9631 1.37739 16 1.56116 16 1.74675C16 1.93234 15.9631 2.11612 15.8913 2.28758C15.8196 2.45904 15.7144 2.61484 15.5819 2.74607L9.00975 9.2523C8.87728 9.3837 8.71994 9.48795 8.54673 9.55909C8.37351 9.63022 8.18783 9.66683 8.0003 9.66683C7.81278 9.66683 7.62709 9.63022 7.45388 9.55909C7.28067 9.48795 7.12332 9.3837 6.99086 9.2523L0.418732 2.74607C0.285995 2.61494 0.180687 2.45917 0.108836 2.28769C0.0369839 2.11622 0 1.9324 0 1.74675C0 1.56111 0.0369839 1.37728 0.108836 1.20581C0.180687 1.03433 0.285995 0.878565 0.418732 0.747429C0.977148 0.208788 1.89352 0.194613 2.45194 0.747429Z",
    fill: "#888281"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorShevron);
export default __webpack_public_path__ + "static/media/vector-shevron.3e8a5e3daaf79d2a7e8e8d3d5db4c7f4.svg";
export { ForwardRef as ReactComponent };